export default abstract class SanitizeDataUtils {
   static isArrayOfString = (parsed: any) => {
      if (Array.isArray(parsed) && parsed.length > 0) {
         return parsed.every((item) => typeof item === 'string');
      }
      return false;
   };
}
